// a setTimeout equivalent
export const delay = (duration: number) => {
    return new Promise((resolve) => {
        setTimeout(resolve, duration);
    });
};

/*
    Wraps a function into a version which repeates the initial function maxTries
    until it returns a success. If no success in accomplished after maxTries
    the function throws the last received error
*/
export const tryUntilSuccess = function (
    func: (...args :any[]) => Promise<any>,
    options?: { maxTries?: number, waitingPeriod?: number, errorCondition: (...args: any) => boolean } | undefined
    ) {
    const maxTries = options && options.maxTries || 5;
    const waitingPeriod = options && options.waitingPeriod || 5000;
    const errorCondition = options && options.errorCondition;

    return async function (...args: any[]) {
        let error;
        for (let i = 0; i < maxTries; i += 1) {
            try {
                const result = await func(...args);
                if (errorCondition && errorCondition(result)) {
                    error = result;
                } else {
                    return result;
                }
            } catch (e) {
                error = e;
            }
            await delay(waitingPeriod);
        }
        if (error instanceof Error) {
            throw error;
        }
        throw new Error(`Invalid return value ${JSON.stringify(error)}`);
    };
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/utils/functional/Promise.ts